// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCardStyles } from "@west/Overrides/Widgets/ProductList/ProductListProductCard";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 128px minmax(0, 471px) 1fr;
        grid-column-gap: 24px;
        width: 100%;
        ${xScreen("lte", "md")} {
            grid-template-columns: 91px minmax(0, 1fr);
            grid-row-gap: 12px;
            height: 100%;
        }
    `,
};
productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 5;
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        &&& .bottom-section {
            margin: 0;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
            margin-top: auto;
        }
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        ${xScreen("lte", "md")} {
            grid-column: 2 / 3;
            &:empty {
                display: none;
            }
        }
    `,
};

productCardStyles.productPriceAndActionsStyles = {
    productListGridContainer: {
        container: {
            css: css`
                max-width: unset;
                width: 100%;
            `,
        },
        info: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            `,
        },
        addToCartActions: {
            css: css`
                margin-top: 8px;
                flex-wrap: wrap;
                ${xScreen("lte", "md")} {
                    gap: 12px;
                    margin-top: 0;
                }
            `,
        },
    },
    authenticationPrompt: {
        container: {
            css: css`
                ${xScreen("lte", "md")} {
                    width: 100%;
                }
            `,
        },
    },
    addToCartActions: {
        css: css`
            display: flex;
            align-items: end;
            gap: 8px;
            flex-wrap: wrap;
            ${xScreen("lte", "md")} {
                gap: 12px;
            }
        `,
    },
    messagesContainer: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;

            margin-top: 8px;
            ${xScreen("lte", "md")} {
                order: -2;
                margin-top: 0;
            }

            &:empty {
                display: none;
            }
        `,
    },
    addToCartButton: {
        mergeCss: true,
        css: css`
            flex: 1;
        `,
    },
    productAvailableStyles: {
        container: {
            css: css`
                ${xScreen("lte", "md")} {
                    width: 100%;
                }
            `,
        },
    },
};

productCardStyles.productInformationStyles = {
    attributes: {
        container: {
            offsetCss: css`
                max-width: 450px;
            `,
        },
    },
    moreOptions: {
        css: css`
            ${xScreen("gt", "md")} {
                ${({ isExist }: any) => (!isExist ? "display: none" : "")};
            }
        `,
    },
};
productCardStyles.variantOptionsTabletStyles = {
    wrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
};
